import React, { useState } from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
import { useTranslation } from "react-i18next";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { Redirect } from "react-router-dom";
import { useAuth } from "views/Authentication/AuthContext";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const { t } = useTranslation();
  const classes = useStyles();
  const { logout } = useAuth();
  const [openProfile, setOpenProfile] = React.useState(null);
  const [navigate, setNavigate] = useState(false);
  const [navigatePasswordChange, setNavigatePasswordChange] = useState(false);

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  const handleOpenProfile = (event) => {
    setNavigate(true);
    setOpenProfile(event.currentTarget);
  };

  const handleOpenPasswordChange = (event) => {
    setNavigatePasswordChange(true);
    setOpenProfile(event.currentTarget);
  };

  if (navigate) {
    return <Redirect to="/profile" />;
  }
  if (navigatePasswordChange) {
    return <Redirect to="/password-update" />;
  }
  return (
    <div>
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={handleOpenProfile}
                      className={classes.dropdownItem}
                    >
                      {t("Profile")}
                    </MenuItem>
                    <Divider light />
                    <MenuItem
                      onClick={handleOpenPasswordChange}
                      className={classes.dropdownItem}
                    >
                      {t("Change Password")}
                    </MenuItem>
                    <Divider light />
                    <MenuItem
                      onClick={() => logout(true)}
                      className={classes.dropdownItem}
                    >
                      {t("Logout")}
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
